import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  Images,
  FolderOpen,
  FileCheck,
  FileX,
  FileClock,
  Heart,
  Archive,
  Printer,
  ChevronDown,
  ChevronUp,
} from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StatsBar() {
  const [stats, setStats] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/stats`, { withCredentials: true })
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  if (!stats) return null;

  const statCards = [
    { label: "Total Images", value: stats.total_images, icon: Images, color: "bg-black", to: "/images" },
    { label: "Bank", value: stats.bank_count || 0, icon: Archive, color: "bg-gray-500", to: "/bank" },
    { label: "Collections", value: stats.total_collections, icon: FolderOpen, color: "bg-gray-700", to: "/collections" },
    { label: "Draft", value: stats.draft_count, icon: FileClock, color: "bg-yellow-500", to: "/images?status=draft" },
    { label: "Affinity", value: stats.affinity_count || 0, icon: Printer, color: "bg-purple-500", to: "/images?status=affinity" },
    { label: "Print Ready", value: stats.print_ready_count || 0, icon: FileCheck, color: "bg-sky-500", to: "/images?status=print-ready" },
    { label: "Approved", value: stats.approved_count, icon: FileCheck, color: "bg-green-600", to: "/images?status=approved" },
    { label: "Rejected", value: stats.rejected_count, icon: FileX, color: "bg-red-600", to: "/images?status=rejected" },
    { label: "Favorites", value: stats.favorites_count, icon: Heart, color: "bg-pink-500", to: "/images?favorites=true" },
  ];

  return (
    <div className="mb-6 border border-gray-200">
      <button
        onClick={() => setCollapsed((prev) => !prev)}
        className="w-full flex items-center justify-between px-3 py-2 bg-gray-50 hover:bg-gray-100 transition-colors border-b border-gray-200"
      >
        <span className="text-[10px] font-medium uppercase tracking-widest text-gray-500">Stats</span>
        {collapsed ? <ChevronDown size={14} className="text-gray-400" /> : <ChevronUp size={14} className="text-gray-400" />}
      </button>

      {!collapsed && (
        <div className="grid grid-cols-3 md:grid-cols-9 divide-x divide-gray-200">
          {statCards.map((stat, i) => {
            const Icon = stat.icon;
            return (
              <Link
                key={i}
                to={stat.to}
                className="p-3 hover:bg-gray-50 transition-colors group"
              >
                <div className={`w-5 h-5 ${stat.color} text-white flex items-center justify-center mb-1.5`}>
                  <Icon size={11} />
                </div>
                <p className="text-lg font-heading font-bold leading-none">{stat.value}</p>
                <p className="text-[9px] text-gray-400 uppercase tracking-widest mt-1">{stat.label}</p>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
